import React from 'react';
import { PiCheckCircleFill } from "react-icons/pi";
import { FaUserTie, FaChartLine } from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi";
import { GiReceiveMoney } from "react-icons/gi";

interface ScenarioTemplateCardProps {
  value: string;
  iconName: string;
  title: string;
  desc: string;
  curKey: string;
  sk: (value: string) => void;
}

// 图标映射表
const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  FaUserTie,
  MdManageAccounts,
  HiUserGroup,
  FaChartLine,
  GiReceiveMoney
};

const ScenarioTemplateCard: React.FC<ScenarioTemplateCardProps> = ({
  value,
  iconName,
  title,
  desc,
  curKey,
  sk
}) => {
  const isSelect = value === curKey;
  const IconComponent = iconMap[iconName] || FaUserTie; // 默认使用 FaUserTie

  return (
    <div 
      className={`border rounded-2xl p-5 flex flex-col group/card cursor-pointer transition-all
        ${isSelect ? "border-black shadow-lg" : "border-[#E9E9E7] hover:border-[#D1D1CF]"}`}
      onClick={() => sk(value)}
    >
      {/* 图片占位区域 - 用图标代替 */}
      <div className="w-full aspect-[4/3] bg-[#F7F7F5] rounded-xl overflow-hidden mb-4 flex items-center justify-center">
        <IconComponent className="text-4xl text-[#91918E] opacity-60 group-hover/card:scale-105 transition-transform duration-700" />
      </div>
      <div>
        <div className="flex items-center gap-1.5 mb-1">
          <h3 className="text-sm font-bold">{title}</h3>
          {isSelect && <PiCheckCircleFill className="text-base text-[#4B5563]" />}
        </div>
        {/* 副标题已移除 */}
      </div>
    </div>
  );
};

export default ScenarioTemplateCard;
